
/**
 * Query param read once in head.html (`query.get(CHECKOUT_THEME_QUERY_PARAM)`).
 * Keep in sync with the indicator script in main-app head.html.
 */
export const CHECKOUT_THEME_QUERY_PARAM = "theme";

/**
 * Html attribute that carries the active checkout theme *name*.
 *
 * `?theme=<name>` is parsed once in head.html and stamped on `<html>` as
 * `data-checkout-theme="<name>"`. Everything downstream reads that attribute
 * only — never the URL query string.
 */
export const CHECKOUT_THEME_DATA_ATTR = "data-checkout-theme";

/**
 * Registry key / `?theme=` query value for the Dineout (Umami) checkout theme.
 * Maps to {@link DineoutTheme} + the `dineout` DLS CSS bundle in checkout-web.
 * Keep in sync with native XP until the URL param is renamed.
 */
export const DINEOUT_CHECKOUT_THEME_NAME = "umami";

/**
 * Resolve the active checkout theme *name* (or `null` for the default checkout).
 * Reads the html attr stamped by head.html / SSR — never the URL query string.
 *
 * Callers map the returned name via the checkout theme registry.
 */
export const getCheckoutThemeName = (): string | null => {
    if (typeof window === "undefined") {
        return null;
    }

    return document.documentElement.getAttribute(CHECKOUT_THEME_DATA_ATTR);
};
